import { render } from "./HorizontalTimeline.vue?vue&type=template&id=1b932f04&scoped=true"
import script from "./HorizontalTimeline.vue?vue&type=script&lang=js"
export * from "./HorizontalTimeline.vue?vue&type=script&lang=js"

import "./HorizontalTimeline.vue?vue&type=style&index=0&id=1b932f04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b932f04"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip});
